import EntityCrudPage from '../../shared/EntityCrudPage';
import { vendorConfig } from '../../config/entityConfigs';

const VendorsPage = () => <EntityCrudPage config={vendorConfig} />;

export default VendorsPage;
